import {
  Box,
  Button,
  Grid,
  MenuItem,
  Modal,
  Select,
  Typography,
} from "@mui/material";
import React, { useEffect, useState } from "react";
import ClienteAmlGiuridico from "./ComponentsAmlGiuridico/ClienteAmlGiuridico";
import EsecutoreAmlGiuridico from "./ComponentsAmlGiuridico/EsecutoreAmlGiuridico";
import TitolareAmlGiuridico from "./ComponentsAmlGiuridico/TitolareAmlGiuridico";
import PrestazioneAmlGiuridico from "./ComponentsAmlGiuridico/PrestazioneAmlGiuridico";
import ModalHelper from "../../Generics/ModalHelper";
import Summary_Aml_Giuridico from "../AML_GIURIDICO/ComponentsAmlGiuridico/Summary_Aml_Giuridico";
import "../../../assets/css/text.css";
import { validationAMLSingleTitolare } from "../../../utils/validation_aml";
import AmlDocument from "../AmlDocument";
import { service } from "../../../model/service";
import PopupError from "../../Generics/PopupError";

const YES_NO_TITOLARE = [
  {
    key: true,
    labelIta: "Esistono uno o più titolari effettivi",
    labelEng: "There are one or more beneficial owners",
  },
  {
    key: false,
    labelIta:
      "Agisco in proprio, quindi non esiste un diverso titolare effettivo",
    labelEng:
      "I act on my own behalf, therefore there is no different beneficial owner",
  },
];


const tooltipContent = {
  esecutoreIta: {
    infoTitle: "Esecutore",
    description: `Per “esecutore” si intende, ai sensi dell’art. 1, co. 2, lett. (p), del D. Lgs. 231/2007: il soggetto delegato ad operare in nome e per conto del cliente o a cui siano comunque conferiti poteri di rappresentanza che gli consentano di operare in nome e per conto del cliente.`,
    descriptionBis: "",
  },
  esecutoreEng: {
    infoTitle: "Executor",
    description: `Pursuant to Article 1, paragraph 2, letter (p) of Legislative Decree 231/2007, the “executor” is the person authorized to operate in the name and on behalf of the client or who is entrusted in any case representation powers enabling it to act in the name and on behalf of the client.`,
    descriptionBis: "",
  },
  titolareIta: {
    infoTitle: "Titolare",
    description: (
      <>
        <Typography component="div">
          Per "titolare effettivo" si intende la persona fisica o le persone
          fisiche, diverse dal cliente, nell'interesse della quale o delle
          quali, in ultima istanza, la prestazione professionale è resa. Ai
          sensi dell'art. 20, D. Lgs. 231/2007, il titolare effettivo di clienti
          diversi dalle persone fisiche coincide con la persona fisica o le
          persone fisiche cui, in ultima istanza, è attribuibile la proprietà
          diretta o indiretta dell'ente ovvero il relativo controllo.
        </Typography>
      </>
    ),
    descriptionBis: "",
  },
  titolareEng: {
    infoTitle: "Ultimate Beneficial Owner (UBO)",
    description: (
      <>
        <Typography component="div">
          The "ultimate beneficial owner" is the individual or the individuals
          (other than the client) on whose behalf the professional activity is
          ultimately carried out. Pursuant to Article 20 of the Legislative
          Decree No. 231/2007 the ultimate beneficial owner of clients other
          than individuals corresponds to the individual(s) to whom the direct
          or indirect ownership or control of the legal entity is ultimately
          attributable.
        </Typography>
      </>
    ),
    descriptionBis: "",
  },
  natura: {
    infoTitle:
      "Natura e scopo della prestazione professionale richiesta allo Studio LEXIA",
    description:
      "Il nome della pratica deve essere così composto: Cliente / Prodotto + Specifica eventuale.",
    descriptionBis:
      "Esempi: Mario Rossi / Costituzione di startup innovativa; Alfa Srl / Contratto di investimento Beta Spa.",
  },
  fonte: {
    infoTitle: "Fonte/i di provenienza dei fondi impiegati per l'operazione",
    description:
      "Il nome della pratica deve essere così composto: Cliente / Prodotto + Specifica eventuale.",
    descriptionBis:
      "Esempi: Mario Rossi / Costituzione di startup innovativa; Alfa Srl / Contratto di investimento Beta Spa.",
  },
  documentiIdentita: {
    infoTitle: "Estremi del documento di identificazione",
    description:
      "Indicare il tipo di documento di identità: Carta d'identità, Passaporto, Patente di guida, ecc.",
    descriptionBis: "",
  },
  scansioneDocumento: {
    infoTitle: "Scansione documento",
    description:
      "Caricare una scansione leggibile fronte/retro del documento di identità indicato.",
    descriptionBis: "",
  },
  documentiRappresentanza: {
    infoTitle: "Documento attestante i poteri di rappresentanza",
    description:
      "Sono esempi di documenti attestanti i poteri di rappresentanza: la procura per le persone fisiche; la visura camerale per le società.",
    descriptionBis: "",
  },
  documentiRappresentanzaEng: {
    infoTitle: "Document certifying powers",
    description:
      "Examples of documents certifying powers of representation include: a power of attorney for natural persons; a Chamber of Commerce register extract for companies.",
    descriptionBis: "",
  },
  politicamenteEspostoIta: {
    infoTitle: "Persona politicamente esposta",
    description: (
      <Typography
        component="div"
        style={{ fontSize: { xs: "14px", md: "16px" } }}
      >
        Per "persone politicamente esposte" ai sensi dell'art. 1, co. 2, lett.
        (dd) del D. Lgs. 231/2007, si intende: le persone fisiche cittadine di
        altri Stati comunitari o di Stati extracomunitari che occupano o hanno
        occupato importanti cariche pubbliche come pure i loro familiari diretti
        o coloro con i quali tali persone intrattengono notoriamente stretti
        legami come di seguito elencate:
        <br />
        <br />
        <strong>1.</strong> sono persone fisiche che occupano o hanno occupato
        importanti cariche pubbliche coloro che ricoprono o hanno ricoperto la
        carica di:
        <br />
        <div style={{ paddingLeft: "16px", marginTop: "6px" }}>
          <div>
            <strong>1.1</strong> Presidente della Repubblica, Presidente del
            Consiglio, Ministro, Vice-Ministro e Sottosegretario, Presidente di
            Regione, assessore regionale, Sindaco di capoluogo di provincia o
            città metropolitana, Sindaco di comune con popolazione non inferiore
            a 15.000 abitanti nonché cariche analoghe in Stati esteri;
          </div>
          <div style={{ marginTop: "4px" }}>
            <strong>1.2</strong> deputato, senatore, parlamentare europeo,
            consigliere regionale nonché cariche analoghe in Stati esteri;
          </div>
          <div style={{ marginTop: "4px" }}>
            <strong>1.3</strong> membro degli organi direttivi centrali di
            partiti politici;
          </div>
          <div style={{ marginTop: "4px" }}>
            <strong>1.4</strong> giudice della Corte Costituzionale, magistrato
            della Corte di Cassazione o della Corte dei conti, consigliere di
            Stato e altri componenti del Consiglio di Giustizia Amministrativa
            per la Regione siciliana nonché cariche analoghe in Stati esteri;
          </div>
          <div style={{ marginTop: "4px" }}>
            <strong>1.5</strong> membro degli organi direttivi delle banche
            centrali e delle autorità indipendenti;
          </div>
          <div style={{ marginTop: "4px" }}>
            <strong>1.6</strong> ambasciatore, incaricato d'affari ovvero
            cariche equivalenti in Stati esteri, ufficiale di grado apicale
            delle forze armate ovvero cariche analoghe in Stati esteri;
          </div>
          <div style={{ marginTop: "4px" }}>
            <strong>1.7</strong> componente degli organi di amministrazione,
            direzione o controllo delle imprese controllate, anche
            indirettamente, dallo Stato italiano o da uno Stato estero ovvero
            partecipate, in misura prevalente o totalitaria, dalle Regioni, da
            comuni capoluoghi di provincia e città metropolitane e da comuni con
            popolazione complessivamente non inferiore a 15.000 abitanti;
          </div>
          <div style={{ marginTop: "4px" }}>
            <strong>1.8</strong> direttore generale di ASL e di azienda
            ospedaliera, di azienda ospedaliera universitaria e degli altri enti
            del servizio sanitario nazionale;
          </div>
          <div style={{ marginTop: "4px" }}>
            <strong>1.9</strong> direttore, vicedirettore e membro dell'organo
            di gestione o soggetto svolgenti funzioni equivalenti in
            organizzazioni internazionali;
          </div>
        </div>
        <br />
        <strong>2.</strong> sono familiari di persone politicamente esposte: i
        genitori, il coniuge o la persona legata in unione civile o convivenza
        di fatto o istituti assimilabili alla persona politicamente esposta, i
        figli e i loro coniugi nonché le persone legate ai figli in unione
        civile o convivenza di fatto o istituti assimilabili;
        <br />
        <br />
        <strong>3.</strong> sono soggetti con i quali le persone politicamente
        esposte intrattengono notoriamente stretti legami:
        <br />
        <div style={{ paddingLeft: "16px", marginTop: "6px" }}>
          <div>
            <strong>3.1</strong> le persone fisiche legate alla persona
            politicamente esposta per via della titolarità effettiva congiunta
            di enti giuridici o di altro stretto rapporto di affari;
          </div>
          <div style={{ marginTop: "4px" }}>
            <strong>3.2</strong> le persone fisiche che detengono solo
            formalmente il controllo totalitario di un'entità notoriamente
            costituita, di fatto, nell'interesse e a beneficio di una persona
            politicamente esposta.
          </div>
        </div>
      </Typography>
    ),
    descriptionBis: "",
  },
  politicamenteEspostoEng: {
    infoTitle: "Politically Exposed Person",
    description: (
      <Typography
        component="div"
        style={{ fontSize: { xs: "14px", md: "16px" } }}
      >
        According to article 1, para. 2, letter (dd) of the Legislative Decree
        No. 231/2007 a "politically exposed person" is any natural person that
        is citizen of a EU or non-EU country which is or has been entrusted with
        prominent public functions as well as their immediate family members and
        relatively close associates, as indicated below:
        <br />
        <br />
        <strong>1.</strong> the individuals that are or have been entrusted with
        prominent public functions are those who are or have been entrusted with
        the following functions:
        <br />
        <div style={{ paddingLeft: "16px", marginTop: "6px" }}>
          <div>
            <strong>1.1</strong> President of the Republic, Prime Minister,
            Minister, Deputy Minister, Deputy Secretary, President of a Region,
            Region Minister, Major of a Province Capital or Metropolitan City,
            Major of a municipality with a population of at least 15,000 people,
            or similar offices in foreign States;
          </div>
          <div style={{ marginTop: "4px" }}>
            <strong>1.2</strong> Member of the House of Representatives, Member
            of the Senate, Member of the European Parliament, Member of a
            Regional Parliament, or similar offices in foreign States;
          </div>
          <div style={{ marginTop: "4px" }}>
            <strong>1.3</strong> Member of central governing bodies of political
            parties;
          </div>
          <div style={{ marginTop: "4px" }}>
            <strong>1.4</strong> Member of the Constitutional Court, the Supreme
            Court (Corte di Cassazione) or the Court of Auditors (Corte dei
            Conti), member of the Supreme Administrative Court (Consigliere di
            Stato) and other members of the Supreme Administrative Court for the
            Region of Sicily (Consiglio di Giustizia Amministrativa per la
            Regione Sicilia), or similar offices in foreign States;
          </div>
          <div style={{ marginTop: "4px" }}>
            <strong>1.5</strong> Member of governing bodies of central banks and
            independent authorities;
          </div>
          <div style={{ marginTop: "4px" }}>
            <strong>1.6</strong> Ambassador, chargé d'affaires or similar
            offices in foreign States, high-ranking officer of the armed forces
            or similar offices in foreign States;
          </div>
          <div style={{ marginTop: "4px" }}>
            <strong>1.7</strong> Member of the administrative, management or
            supervisory bodies of enterprises that are controlled, also
            indirectly, by the Italian State or a foreign State or that mainly
            or fully participated by a Region, a Province Capital, a
            Metropolitan City and a Municipality with a population of at least
            15,000 people;
          </div>
          <div style={{ marginTop: "4px" }}>
            <strong>1.8</strong> General manager of a local health enterprise
            (ASL) and hospitality enterprise (azienda ospedaliera),
            university-linked hospitality enterprise (az. ospedaliera
            universitaria) and other entities belonging to the Italian national
            health system;
          </div>
          <div style={{ marginTop: "4px" }}>
            <strong>1.9</strong> Manager, deputy manager and managing body
            members (or anybody with equivalent functions) of int'l
            organisations.
          </div>
        </div>
        <br />
        <strong>2.</strong> immediate family members of a PEP include the
        following: the parents, the spouse or person linked under civil
        partnership (unione civile) or unregistered cohabitation (convivenza di
        fatto) or under equivalent arrangements with a PEP, the children of the
        PEP and their spouses as well as the persons that are linked to the
        children of the PEP under civil partnership (unione civile) or
        unregistered cohabitation (convivenza di fatto);
        <br />
        <br />
        <strong>3.</strong> relatively close associates of a PEP include the
        following:
        <br />
        <div style={{ paddingLeft: "16px", marginTop: "6px" }}>
          <div>
            <strong>3.1</strong> any natural person who are known to have
            beneficial ownership of legal entities, trusts or similar legal
            arrangements jointly with the PEP, or have close business relations
            with the PEP;
          </div>
          <div style={{ marginTop: "4px" }}>
            <strong>3.2</strong> any natural person having only formally the
            full ownership of an entity which is known to be set up in the
            interest and for the benefit of a PEP.
          </div>
        </div>
      </Typography>
    ),
    descriptionBis: "",
  },
  titoloEsecutoreIta: {
    infoTitle: "Titolo",
    description:
      "Sono esempi di titoli di esecutore: il procuratore per le persone fisiche; il legale rappresentante per le società.",
    descriptionBis: "",
  },
  titoloEsecutoreEng: {
    infoTitle: "Title",
    description:
      "Examples of executor titles include: a proxy holder for natural persons; a legal representative for companies.",
    descriptionBis: "",
  },
  titolareIta: {
    infoTitle: "Titolare effettivo",
    description: (
      <Typography
        component="div"
        style={{ fontSize: { xs: "14px", md: "16px" } }}
      >
        Per "titolare effettivo" si intende la persona fisica o le persone
        fisiche, diverse dal cliente, nell'interesse della quale o delle quali,
        in ultima istanza, la prestazione professionale è resa.
        <br />
        Ai sensi dell'art. 20, D. Lgs. 231/2007, il titolare effettivo di
        clienti diversi dalle persone fisiche coincide con la persona fisica o
        le persone fisiche cui, in ultima istanza, è attribuibile la proprietà
        diretta o indiretta dell'ente ovvero il relativo controllo.
        <br />
        Nel caso in cui il cliente sia una società di capitali:
        <div style={{ paddingLeft: "16px", marginTop: "4px" }}>
          <div>
            <strong>a</strong>. costituisce indicazione di proprietà diretta la
            titolarità di una partecipazione superiore al 25 per cento del
            capitale del cliente, detenuta da una persona fisica;
          </div>
          <div style={{ marginTop: "4px" }}>
            <strong>b</strong>. costituisce indicazione di proprietà indiretta
            la titolarità di una percentuale di partecipazioni superiore al 25
            per cento del capitale del cliente, posseduto per il tramite di
            società controllate, società fiduciarie o per interposta persona.
          </div>
        </div>
        <br />
        Nelle ipotesi in cui l'esame dell'assetto proprietario non consenta di
        individuare in maniera univoca la persona fisica o le persone fisiche
        cui è attribuibile la proprietà diretta o indiretta dell'ente, il
        titolare effettivo coincide con la persona fisica o le persone fisiche
        cui, in ultima istanza, è attribuibile il controllo del medesimo in
        forza:
        <div style={{ paddingLeft: "16px", marginTop: "4px" }}>
          <div>
            <strong>a</strong>. del controllo della maggioranza dei voti
            esercitabili in assemblea ordinaria;
          </div>
          <div style={{ marginTop: "4px" }}>
            <strong>b</strong>. del controllo di voti sufficienti per esercitare
            un'influenza dominante in assemblea ordinaria;
          </div>
          <div style={{ marginTop: "4px" }}>
            <strong>c</strong>. dell'esistenza di particolari vincoli
            contrattuali che consentano di esercitare un'influenza dominante.
          </div>
        </div>
        <br />
        Qualora l'applicazione dei criteri di cui sopra non consenta di
        individuare univocamente uno o più titolari effettivi, il titolare
        effettivo coincide con la persona fisica o le persone fisiche titolari
        di poteri di amministrazione o direzione della società.
        <br />
        Nel caso in cui il cliente sia una persona giuridica privata, di cui al
        decreto del Presidente della Repubblica 10 febbraio 2000, n. 361, sono
        cumulativamente individuati, come titolari effettivi:
        <div style={{ paddingLeft: "16px", marginTop: "4px" }}>
          <div>
            <strong>a</strong>. i fondatori, ove in vita;
          </div>
          <div style={{ marginTop: "4px" }}>
            <strong>b</strong>. i beneficiari, quando individuati o facilmente
            individuabili;
          </div>
          <div style={{ marginTop: "4px" }}>
            <strong>c</strong>. i titolari di funzioni di direzione e
            amministrazione.
          </div>
        </div>
      </Typography>
    ),
    descriptionBis: "",
  },
  titolareEng: {
    infoTitle: "Ultimate Beneficial Owner",
    description: (
      <Typography
        component="div"
        style={{ fontSize: { xs: "14px", md: "16px" } }}
      >
        The "ultimate beneficial owner" is the individual or the individuals
        (other than the client) on whose behalf the professional activity is
        ultimately carried out.
        <br />
        Pursuant to Article 20 of the Legislative Decree No. 231/2007 the
        ultimate beneficial owner of clients other than individuals corresponds
        to the individual(s) to whom the direct or indirect ownership or control
        of the legal entity is ultimately attributable.
        <br />
        If the client is a company:
        <div style={{ paddingLeft: "16px", marginTop: "4px" }}>
          <div>
            <strong>a</strong>. the ownership of more than 25 per cent of the
            capital by an individual represents an indication of direct
            ownership;
          </div>
          <div style={{ marginTop: "4px" }}>
            <strong>b</strong>. the indirect ownership of more than 25 per cent
            of the capital through subsidiaries, trusts or nominees represents
            an indication of indirect ownership.
          </div>
        </div>
        <br />
        If the examination of the ownership structure does not allow to identify
        without any doubt the individual(s) to whom the direct or indirect
        ownership of the entity is attributable, the ultimate beneficial
        owner(s) is/are the individual(s) to whom the control of the entity is
        ultimately attributable by virtue of:
        <div style={{ paddingLeft: "16px", marginTop: "4px" }}>
          <div>
            <strong>a</strong>. the control of the majority of the voting rights
            that can be exercised at the ordinary shareholders' meeting;
          </div>
          <div style={{ marginTop: "4px" }}>
            <strong>b</strong>. the control of an amount of voting rights
            sufficient to exercise a dominant influence at the ordinary
            shareholders' meeting;
          </div>
          <div style={{ marginTop: "4px" }}>
            <strong>c</strong>. the existence of particular contractual
            arrangements allowing the exercise of a dominant influence.
          </div>
        </div>
        <br />
        If it is not possible to identify without any doubt one or more ultimate
        beneficial owners on the basis of the above criteria, the ultimate
        beneficial owner(s) shall be the individual or individuals with
        administrative or management powers in the company.
        <br />
        If the client is a private legal person, as referred to in the
        Presidential Decree No. 361 of 10 February 2000, the following persons
        must all be considered to be the ultimate beneficial owners:
        <div style={{ paddingLeft: "16px", marginTop: "4px" }}>
          <div>
            <strong>a</strong>. the founders, if still alive;
          </div>
          <div style={{ marginTop: "4px" }}>
            <strong>b</strong>. the beneficiaries, when identified or easily
            identifiable;
          </div>
          <div style={{ marginTop: "4px" }}>
            <strong>c</strong>. the holders of management and administrative
            functions.
          </div>
        </div>
      </Typography>
    ),
    descriptionBis: "",
  },
  ragioneTitolareIta: {
    infoTitle: "Ragione cui il soggetto si qualifica quale titolare effettivo",
    description:
      "Sono esempi di ragioni: la titolarità di una partecipazione superiore al 25% del capitale del cliente; il controllo della maggioranza dei voti esercitabili in assemblea ordinaria; il controllo di voti sufficienti per esercitare un'influenza dominante in assemblea ordinaria; l'esistenza di particolari vincoli contrattuali che consentano di esercitare un'influenza dominante.",
    descriptionBis: "",
  },
  ragioneTitolareEng: {
    infoTitle: "Reason why the person qualifies as ultimate beneficial owner",
    description:
      "Examples of reasons include: ownership of a shareholding exceeding 25% of the client's capital; control of the majority of voting rights exercisable at ordinary shareholders' meetings; control of a sufficient number of votes to exercise a dominant influence at ordinary shareholders' meetings; the existence of specific contractual arrangements that allow the exercise of a dominant influence.",
    descriptionBis: "",
  },
  fonteIta: {
    infoTitle: "Fonte/i di provenienza dei fondi impiegati per l'operazione",
    description:
      "Sono esempi di fonti di provenienza dei fondi: reddito da lavoro; reddito di impresa; liquidità del conto corrente; vendita di beni.",
    descriptionBis: "",
  },
  fonteEng: {
    infoTitle: "Source(s) of funds used for the transaction",
    description:
      "Examples of sources of funds include: employment income; business income; bank account liquidity; sale of assets.",
    descriptionBis: "",
  },
};

const AML_GIURIDICO = ({
  languange,
  handleAmlUpdate,
  aml,
  currentStep,
  errors,
  urlParamsAml,
  goToStep,
  caseData,
  saveAml,
  uid,
  documents,
  refreshDocuments,
  saveAmlData,
}) => {
  const [openModal, setOpenModal] = useState(false);
  const [singleTitolare, setSingleTitolare] = useState({});
  const [indexTitolare, setIndexTitolare] = useState(null);
  const [errorsTitolare, setErrorsTitolare] = useState([]);
  const [errorPopupTitolare, setErrorPopupTitolare] = useState(false);
  const [hasBeneficialOwner, setHasBeneficialOwner] = useState(true);
  const [beneficialOwners, setBeneficialOwners] = useState(
    aml?.beneficial_owners || [],
  );

  const [modalOpen, setModalOpen] = useState(false);
  const [modalObjectInfo, setModalObjectInfo] = useState({});

  useEffect(() => {
    if (errorPopupTitolare) {
      const timer = setTimeout(() => setErrorPopupTitolare(false), 3000);
      return () => clearTimeout(timer);
    }
  }, [errorPopupTitolare]);

  useEffect(() => {
    if (currentStep === 3) {
      handleAmlUpdate({
        ...aml,
        has_beneficial_owner: hasBeneficialOwner,
        beneficial_owners: beneficialOwners,
      });
    }
  }, [hasBeneficialOwner, beneficialOwners]);

  const t = (eng, ita) => (languange === "ENG" ? eng : ita);

  const getBeneficialOwnerIndices = () => beneficialOwners.map((_, i) => i);

  const getEditData = (index) => beneficialOwners[index] || {};

  const handleOpenModal = () => setOpenModal(true);

  const handleCloseModal = async () => {
    if (indexTitolare === null) {
      const newIdx = beneficialOwners.length;
      const prefixes = [`titolare_${newIdx}_`, `beneficial_owner_${newIdx}_`];
      const docsToDelete = (documents || []).filter((d) => {
        const base =
          d.assigned_name?.split(".")[0] ?? d.original_name?.split(".")[0];
        return prefixes.some((p) => base?.startsWith(p));
      });
      for (const doc of docsToDelete) {
        try {
          await service.deleteDocument(doc.id);
        } catch (err) {
          console.error("Errore eliminazione doc titolare:", err);
        }
      }
      if (docsToDelete.length > 0 && typeof refreshDocuments === "function") {
        await refreshDocuments();
      }
    }
    setOpenModal(false);
    setIndexTitolare(null);
  };

  const handleSaveAndAddTitolare = async () => {
    const idx =
      indexTitolare !== null ? indexTitolare : beneficialOwners.length;

    const validationErrors = validationAMLSingleTitolare(
      singleTitolare,
      documents,
      idx,
      urlParamsAml,
    );

    if (validationErrors.length > 0) {
      setErrorsTitolare(validationErrors);
      setErrorPopupTitolare(true);
      return;
    }
    setErrorsTitolare([]);
    const newOwners = [...beneficialOwners];
    if (indexTitolare !== null) {
      newOwners[indexTitolare] = singleTitolare;
    } else {
      newOwners.push(singleTitolare);
    }
    setBeneficialOwners(newOwners);
    const updatedAml = {
      ...aml,
      has_beneficial_owner: hasBeneficialOwner,
      beneficial_owners: newOwners,
    };
    handleAmlUpdate(updatedAml);
    if (typeof saveAmlData === "function") await saveAmlData(updatedAml);
    setOpenModal(false);
    setIndexTitolare(null);
  };

  const handleRemoveTitolare = async (index) => {
    const prefixes = [`titolare_${index}_`, `beneficial_owner_${index}_`];
    const docsToDelete = (documents || []).filter((d) => {
      const base =
        d.assigned_name?.split(".")[0] ?? d.original_name?.split(".")[0];
      return prefixes.some((p) => base?.startsWith(p));
    });
    for (const doc of docsToDelete) {
      try {
        await service.deleteDocument(doc.id);
      } catch (err) {
        console.error("Errore eliminazione doc titolare:", err);
      }
    }
    if (docsToDelete.length > 0 && typeof refreshDocuments === "function") {
      await refreshDocuments();
    }
    const newOwners = beneficialOwners.filter((_, i) => i !== index);
    setBeneficialOwners(newOwners);
    const updatedAml = {
      ...aml,
      has_beneficial_owner: hasBeneficialOwner,
      beneficial_owners: newOwners,
    };
    handleAmlUpdate(updatedAml);
    if (typeof saveAmlData === "function") await saveAmlData(updatedAml);
    setOpenModal(false);
  };

  const handleModalHelperClick = (objectInfo) => {
    setModalObjectInfo(objectInfo);
    setModalOpen(true);
  };
  const handleCloseHelperModal = () => {
    setModalOpen(false);
    setModalObjectInfo({});
  };

  const stepTitles = {
    1: (
      <Typography className="color-blue-dark title-step">
        {t("Client", "Cliente")}
      </Typography>
    ),
    2: (
      <Typography className="color-blue-dark title-step">
        {t("Executor", "Esecutore")}
      </Typography>
    ),
    3: (
      <Typography className="color-blue-dark title-step">
        {t("Ultimate Beneficial Owner (UBO)", "Titolare effettivo (UBO)")}
      </Typography>
    ),
    4: (
      <Typography className="color-blue-dark title-step">
        {t("Services", "Prestazione")}
      </Typography>
    ),
  };

  return (
    <>
      <Grid
        container
        style={{
          display: "flex",
          justifyContent: "center",
          marginBottom: "100px",
        }}
      >
        <Grid item xs={11} sm={10} style={{ marginTop: "30px" }}>
          <Grid
            xs={12}
            item
            container
            sx={{
              display: "flex",
              justifyContent: { xs: "center", md: "start" },
            }}
          >
            <Grid item xs={11} md={4}>
              {stepTitles[currentStep] ?? null}
            </Grid>
          </Grid>

          {/* ── STEP 1 ── */}
          {currentStep === 1 && (
            <Grid
              xs={12}
              item
              container
              sx={{
                display: "flex",
                justifyContent: { xs: "center", md: "start" },
              }}
            >
              <ClienteAmlGiuridico
                caseData={caseData}
                languange={languange}
                handleAmlUpdate={handleAmlUpdate}
                aml={aml}
                errors={errors}
                saveAml={saveAml}
                documents={documents}
                refreshDocuments={refreshDocuments}
                saveAmlData={saveAmlData}
              />
            </Grid>
          )}

          {/* ── STEP 2 ── */}
          {currentStep === 2 && (
            <Grid
              xs={12}
              item
              container
              sx={{
                display: "flex",
                justifyContent: { xs: "center", md: "start" },
              }}
            >
              <Grid xs={11} md={12} item container style={{ marginTop: "12px" }}>
                <Grid item xs={11.5} md={10} lg={8}>
                  <Box
                    className="bg-azure-light"
                    sx={{
                      display: "flex",
                      alignItems: "center",
                      gap: "14px",
                      borderRadius: "8px",
                      padding: "16px 20px",
                      marginBottom: "16px",
                    }}
                  >
                    <div
                      className="icon-modal-info-helper"
                      style={{ flexShrink: 0 }}
                    />
                    <Typography style={{ fontSize: "14px", lineHeight: 1.6 }}>
                      {t(
                        "Generally speaking, the executor is a person who acts in the name or on behalf of the client in the context of the operation.",
                        "A livello indicativo, l'esecutore è il soggetto che opera in nome o per conto del cliente nell'ambito dell'operazione.",
                      )}{" "}
                      <span
                        style={{
                          textDecoration: "underline",
                          cursor: "pointer",
                          fontWeight: 500,
                        }}
                        onClick={() =>
                          handleModalHelperClick(
                            t(
                              tooltipContent.esecutoreEng,
                              tooltipContent.esecutoreIta,
                            ),
                          )
                        }
                      >
                        {t("Learn more", "Approfondisci")}
                      </span>
                    </Typography>
                  </Box>
                </Grid>
              </Grid>
              <EsecutoreAmlGiuridico
                languange={languange}
                handleAmlUpdate={handleAmlUpdate}
                aml={aml}
                errors={errors}
                tooltipContent={tooltipContent}
                saveAml={saveAml}
                documents={documents}
                refreshDocuments={refreshDocuments}
                saveAmlData={saveAmlData}
              />
            </Grid>
          )}

          {/* ── STEP 3: TITOLARE ── */}
          {currentStep === 3 && (
            <Grid
              xs={12}
              item
              container
              sx={{
                display: "flex",
                justifyContent: { xs: "center", md: "start" },
                alignItems: "flex-end",
              }}
            >
              <Grid xs={11} md={12} item container style={{ marginTop: "12px" }}>
                <Grid item xs={11.5} md={10} lg={8}>
                  <Box
                    className="bg-azure-light"
                    sx={{
                      display: "flex",
                      alignItems: "center",
                      gap: "14px",
                      borderRadius: "8px",
                      padding: "16px 20px",
                      marginBottom: "16px",
                    }}
                  >
                    <div
                      className="icon-modal-info-helper"
                      style={{ flexShrink: 0 }}
                    />
                    <Typography style={{ fontSize: "14px", lineHeight: 1.6 }}>
                      {t(
                        "Generally speaking, the ultimate beneficial owner is the person who owns or controls the company/client. The relevant threshold is 25% of the capital.",
                        "In linea generale, il titolare effettivo è la persona che possiede o controlla la società/cliente. Nelle società di capitali rileva la soglia del 25% del capitale.",
                      )}{" "}
                      <span
                        style={{
                          textDecoration: "underline",
                          cursor: "pointer",
                          fontWeight: 500,
                        }}
                        onClick={() =>
                          handleModalHelperClick(
                            t(
                              tooltipContent.titolareEng,
                              tooltipContent.titolareIta,
                            ),
                          )
                        }
                      >
                        {t("Learn more", "Approfondisci")}
                      </span>
                    </Typography>
                  </Box>
                </Grid>
              </Grid>
              {/* ── Select ── */}
              <Grid item xs={11} md={4}>
                <div style={{ display: "flex", alignItems: "center" }}>
                  <Typography className="color-blue-dark title-input">
                    {t("UBO", "Dichiarazione")}
                  </Typography>
                </div>
                <Select
                  name="has_beneficial_owner"
                  disabled
                  error={errors.includes("has_beneficial_owner")}
                  value={
                    hasBeneficialOwner === "" || hasBeneficialOwner == null
                      ? ""
                      : String(hasBeneficialOwner)
                  }
                  onChange={async (e) => {
                    const newVal =
                      e.target.value === "true"
                        ? true
                        : e.target.value === "false"
                          ? false
                          : "";
                    if (hasBeneficialOwner === true && newVal === false) {
                      const docsToDelete = (documents || []).filter((d) => {
                        const baseName =
                          d.assigned_name?.split(".")[0] ??
                          d.original_name?.split(".")[0];
                        return (
                          baseName?.startsWith("titolare_") ||
                          baseName?.startsWith("beneficial_owner_")
                        );
                      });
                      for (const doc of docsToDelete) {
                        try {
                          await service.deleteDocument(doc.id);
                        } catch (err) {
                          console.error(
                            "Errore eliminazione doc titolari:",
                            err,
                          );
                        }
                      }
                      if (
                        docsToDelete.length > 0 &&
                        typeof refreshDocuments === "function"
                      )
                        await refreshDocuments();
                      setBeneficialOwners([]);
                      const updatedAml = {
                        ...aml,
                        has_beneficial_owner: false,
                        beneficial_owners: [],
                      };
                      handleAmlUpdate(updatedAml);
                      if (typeof saveAmlData === "function")
                        await saveAmlData(updatedAml);
                    }
                    setHasBeneficialOwner(newVal);
                  }}
                  displayEmpty
                  fullWidth
                  sx={{ marginTop: "0px", width: "95%" }}
                >
                  <MenuItem value="">
                    <span style={{ color: "#abb0b6" }}>Seleziona</span>
                  </MenuItem>
                  {YES_NO_TITOLARE.map((item, i) => (
                    <MenuItem key={i} value={String(item.key)}>
                      {t(item.labelEng, item.labelIta)}
                    </MenuItem>
                  ))}
                </Select>
              </Grid>

              {/* ── Button ── */}
              <Grid
                item
                xs={11}
                md={8}
                sx={{
                  marginTop: { xs: "20px", md: 0 },
                  marginBottom: { xs: 0, md: "12px" },
                  display: "flex",
                  justifyContent: "flex-end",
                }}
              >
                {hasBeneficialOwner === true && (
                  <Button
                    variant="outlined"
                    onClick={handleOpenModal}
                    sx={{
                      height: "40px",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      position: "relative",
                      px: "12px",
                    }}
                    className="button-bg-empty-aml"
                  >
                    <div
                      className="icon-button-add-titolare"
                      style={{
                        position: "absolute",
                        left: "14px",
                        flexShrink: 0,
                      }}
                    />
                    <Typography
                      className="color-blue-dark"
                      style={{
                        textTransform: "initial",
                        fontSize: "16px",
                        marginLeft: "15px",
                        fontWeight: 500,
                      }}
                    >
                      {t("Add UBO", "Aggiungi Titolare")}
                    </Typography>
                  </Button>
                )}
              </Grid>

              {/* ── Card Titolari ── */}
              {hasBeneficialOwner === true &&
                getBeneficialOwnerIndices().length > 0 && (
                  <Grid
                    item
                    container
                    xs={12}
                    sx={{
                      marginTop: "20px",
                      display: "flex",
                      justifyContent: { xs: "center", md: "center" },
                    }}
                  >
                    {getBeneficialOwnerIndices().map((idx) => (
                      <Grid
                        key={idx}
                        item
                        xs={11}
                        md={8}
                        className="card_titolari"
                        sx={{
                          marginTop: { xs: "20px", md: "20px" },
                          display: "flex",
                          justifyContent: "space-between",
                        }}
                      >
                        <Grid
                          item
                          xs={8}
                          md={9}
                          style={{ paddingLeft: "30px" }}
                        >
                          {beneficialOwners[idx]?.first_name}{" "}
                          {beneficialOwners[idx]?.last_name}
                        </Grid>
                        <Grid
                          item
                          xs={4}
                          md={3}
                          style={{
                            display: "flex",
                            justifyContent: "flex-end",
                            paddingRight: "30px",
                          }}
                        >
                          <Box
                            className="icon-edit-titolare"
                            onClick={() => {
                              setIndexTitolare(idx);
                              handleOpenModal();
                            }}
                            style={{ cursor: "pointer" }}
                          />
                        </Grid>
                      </Grid>
                    ))}
                  </Grid>
                )}
            </Grid>
          )}

          {/* ── STEP 4 ── */}
          {currentStep === 4 && (
            <Grid
              xs={12}
              item
              container
              sx={{
                display: "flex",
                justifyContent: { xs: "center", md: "start" },
              }}
            >
              <PrestazioneAmlGiuridico
                languange={languange}
                handleAmlUpdate={handleAmlUpdate}
                aml={aml}
                errors={errors}
                tooltipContent={tooltipContent}
                natureOptions={
                  caseData?.form?.groups
                    ?.flatMap((g) => g.questions)
                    ?.find((q) => q.key === "service.nature")?.options ?? []
                }
                fundsSourceOptions={
                  caseData?.form?.groups
                    ?.flatMap((g) => g.questions)
                    ?.find((q) => q.key === "service.funds_source")?.options ?? []
                }
              />
            </Grid>
          )}

          {/* ── STEP 5 ── */}
          {currentStep === 5 && (
            <Summary_Aml_Giuridico
              goToStep={goToStep}
              urlParamsAml={urlParamsAml}
              languange={languange}
              aml={aml}
            />
          )}

          {currentStep === 6 && (
            <AmlDocument
              caseData={caseData}
              languange={languange}
              uid={uid}
              documents={documents}
              refreshDocuments={refreshDocuments}
            />
          )}
        </Grid>
      </Grid>

      {/* ── MODALE TITOLARE ── */}
      <Modal open={openModal} onClose={handleCloseModal}>
        <Grid
          container
          justifyContent="center"
          alignItems="center"
          sx={{ height: "100vh" }}
        >
          <Grid
            item
            xs={11}
            sx={{
              maxHeight: "90vh",
              bgcolor: "white",
              boxShadow: 24,
              borderRadius: "16px",
              overflow: "hidden",
              display: "flex",
              flexDirection: "column",
            }}
          >
            <Box
              sx={{
                padding: { xs: "30px 10px 0px", md: "30px 50px 0px" },
                flexShrink: 0,
              }}
            >
              <Grid
                xs={12}
                item
                container
                style={{ display: "flex", justifyContent: "center" }}
              >
                <Grid xs={11} md={12} item>
                  <div style={{ display: "flex", justifyContent: "center" }}>
                    <Grid item xs={10}>
                      <Typography
                        className="color-blue-dark title-step"
                        sx={{ marginBottom: "20px" }}
                      >
                        {indexTitolare !== null
                          ? t(
                              "Edit Owner Details",
                              "Modifica Dettagli Titolare",
                            )
                          : t(
                              "Add Owner Details",
                              "Aggiungi Dettagli Titolare",
                            )}
                      </Typography>
                    </Grid>
                    <Grid
                      item
                      xs={2}
                      style={{
                        display: "flex",
                        justifyContent: "flex-end",
                        alignItems: "start",
                      }}
                    >
                      <Box
                        sx={{ marginTop: { xs: "10px", md: "5px" } }}
                        onClick={handleCloseModal}
                        className="icon-modal-close"
                      />
                    </Grid>
                  </div>
                </Grid>
              </Grid>
            </Box>

            <Box
              sx={{
                overflowY: "auto",
                flex: 1,
                padding: { xs: "0px 10px 30px", md: "0px 50px 30px" },
              }}
            >
              <Grid
                xs={12}
                item
                container
                sx={{
                  display: "flex",
                  justifyContent: { xs: "center", md: "start" },
                }}
              >
                <TitolareAmlGiuridico
                  errors={errorsTitolare}
                  languange={languange}
                  existingData={
                    indexTitolare !== null ? getEditData(indexTitolare) : {}
                  }
                  indexTitolare={indexTitolare}
                  setSingleTitolare={setSingleTitolare}
                  tooltipContent={tooltipContent}
                  saveAml={saveAml}
                  documents={documents}
                  refreshDocuments={refreshDocuments}
                  saveAmlData={saveAmlData}
                  beneficialOwnersCount={beneficialOwners.length}
                />
              </Grid>

              <Grid
                item
                container
                xs={12}
                sx={{
                  display: "flex",
                  justifyContent: "center",
                  marginTop: "30px",
                }}
              >
                <Grid
                  item
                  xs={11}
                  md={12}
                  sx={{ display: "flex", justifyContent: "space-between" }}
                >
                  {indexTitolare !== null && (
                    <Button
                      className="button-bg-empty"
                      sx={{
                        height: "40px",
                        width: {
                          xs: "120px !important",
                          md: "140px !important",
                        },
                      }}
                      onClick={() => handleRemoveTitolare(indexTitolare)}
                    >
                      <Typography
                        className="color-blue-dark"
                        style={{
                          textTransform: "initial",
                          fontSize: "18px",
                          fontWeight: 500,
                        }}
                      >
                        {t("Remove", "Rimuovi")}
                      </Typography>
                    </Button>
                  )}
                  <Button
                    className="button-bg-purple"
                    sx={{
                      height: "40px",
                      marginLeft: "auto",
                      width: { xs: "120px !important", md: "140px !important" },
                    }}
                    onClick={handleSaveAndAddTitolare}
                  >
                    <Typography
                      className="color-light"
                      style={{
                        textTransform: "initial",
                        fontSize: "18px",
                        fontWeight: 500,
                      }}
                    >
                      {t("Save", "Salva")}
                    </Typography>
                  </Button>
                </Grid>
              </Grid>
            </Box>
          </Grid>
        </Grid>
      </Modal>

      {errorPopupTitolare && (
        <Box
          sx={{
            width: { xs: "90%", sm: "350px" },
            position: "fixed",
            bottom: "-15px",
            left: "50%",
            backgroundColor: "#fff",
            transform: "translate(-50%, -50%)",
            zIndex: 1400,
            padding: "12px 10px",
            borderRadius: "10px",
            boxShadow: "0px 4px 6px rgba(0, 0, 0, 0.2)",
            fontSize: "14px",
          }}
        >
          <PopupError
            copyError={
              languange === "ENG"
                ? "One or more required fields are missing"
                : "Uno o più campi obbligatori sono mancanti"
            }
            closePopupError={() => setErrorPopupTitolare(false)}
          />
        </Box>
      )}

      {/* ── MODALE HELPER ── */}
      <Modal open={modalOpen} onClose={handleCloseHelperModal}>
        <div>
          <ModalHelper
            onClose={handleCloseHelperModal}
            modalObjectInfo={modalObjectInfo}
            fullWidth={true}
          />
        </div>
      </Modal>
    </>
  );
};

export default AML_GIURIDICO;
